var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { useMutation, useQuery, useQueryClient } from 'react-query';
import queries from 'constants/queries';
import ApiService from './ApiService';
import { MedicalCenter } from 'models';
import { instanceToPlain, plainToInstance } from 'class-transformer';
var MedicalCenterService = /** @class */ (function (_super) {
    __extends(MedicalCenterService, _super);
    function MedicalCenterService() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.medicalCenterPath = 'medical_centers/';
        _this.successMessage = '';
        return _this;
    }
    MedicalCenterService.prototype.useMedicalCenterInfo = function () {
        var _this = this;
        return useQuery([queries.medicalCenters, 'current'], function () {
            return _this.get("".concat(_this.medicalCenterPath, "/current"));
        }, {
            select: function (response) {
                var data = response.data;
                return plainToInstance(MedicalCenter, data);
            }
        });
    };
    MedicalCenterService.prototype.useEditMedicalCenterConfig = function () {
        var _this = this;
        var queryClient = useQueryClient();
        return useMutation(function (_a) {
            var medicalCenterConfig = _a.medicalCenterConfig, successMessage = _a.successMessage;
            _this.successMessage = successMessage;
            var data = {
                medical_center: {
                    config: instanceToPlain(medicalCenterConfig)
                }
            };
            return _this.put("".concat(_this.medicalCenterPath, "/update_config"), { data: data });
        }, {
            onSuccess: function () {
                queryClient.refetchQueries({ queryKey: [queries.medicalCenters, 'current'] });
                _this.dipatachCreationSuccess({ successMessage: _this.successMessage });
            }
        });
    };
    MedicalCenterService.getInstance = function () {
        if (!MedicalCenterService.medicalCenterInstance) {
            MedicalCenterService.medicalCenterInstance = new MedicalCenterService();
        }
        return MedicalCenterService.medicalCenterInstance;
    };
    return MedicalCenterService;
}(ApiService));
export default MedicalCenterService;
